exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-datatable tr td[data-v-59cbc985]:last-child {\n  display: table-cell !important;\n}\n", ""]);

// exports
